import React from 'react'
import PropTypes from 'prop-types'

const STATUS_CHIP = {
  APPROVED: 'bg-success-500/20 text-success-400',
  PENDING: 'bg-yellow-500/20 text-yellow-300',
  NEW: 'bg-sky-400/20 text-sky-300',
  DENIED: 'bg-red-500/20 text-red-400',
  REJECTED: 'bg-red-500/20 text-red-400',
  CANCELED: 'bg-red-500/20 text-red-400',
  WITHDRAWN: 'bg-gray-700 text-gray-300',
}

/** Coloured pill for a record status (APPROVED, PENDING, ...), or a custom label. */
export const StatusChip = ({ status, label, className }) => (
  <span
    className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${className || STATUS_CHIP[status] || 'bg-gray-700 text-gray-300'}`}
  >
    {label || (status ? status.charAt(0) + status.slice(1).toLowerCase() : '')}
  </span>
)

/**
 * One record on a phone-width list (see DataTable's renderCard): a headline
 * amount with a chip beside it, label/value rows, then actions.
 */
const ListCard = ({ label, title, subtitle, chip, rows, children, actions }) => (
  <div className="rounded-xl border border-gray-200 bg-white p-4 dark:border-[#30363d] dark:bg-transparent">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        {label && <div className="text-xs uppercase tracking-wide text-gray-400">{label}</div>}
        <div className="text-lg font-bold text-gray-900 dark:text-gray-100">{title}</div>
        {subtitle && <div className="text-xs text-gray-400">{subtitle}</div>}
      </div>
      {chip}
    </div>

    {children}

    {rows && rows.filter(Boolean).length > 0 && (
      <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-gray-200 pt-3 text-sm dark:border-gray-700">
        {rows.filter(Boolean).map((row) => (
          <div key={row.label} className={row.full ? 'col-span-2' : undefined}>
            <dt className="text-xs text-gray-400">{row.label}</dt>
            <dd className="font-semibold text-gray-800 dark:text-gray-100">{row.value ?? '—'}</dd>
          </div>
        ))}
      </dl>
    )}

    {actions && <div className="mt-4 flex gap-2">{actions}</div>}
  </div>
)

ListCard.propTypes = {
  label: PropTypes.node,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  chip: PropTypes.node,
  rows: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.node, full: PropTypes.bool }),
    PropTypes.oneOf([false, null, undefined]),
  ])),
  actions: PropTypes.node,
}

export default ListCard
